// frontend/src/config.js
// Helper function to normalize API paths (remove trailing slashes)
const normalizePath = (path) => (path || '').replace(/\/+$/, '');

const config = {
  api: {
    // Base URL for all API calls
    baseURL: process.env.REACT_APP_API_BASE_URL || '',
    
    // Individual API endpoints (using relative paths for production)
    // Normalized to remove trailing slashes to prevent double slashes
    auth: normalizePath(process.env.REACT_APP_AUTH_API || '/api/auth'),
    user: normalizePath(process.env.REACT_APP_USER_API || '/api/user'),
    trade: normalizePath(process.env.REACT_APP_TRADE_API || '/api/trade'),
    admin: normalizePath(process.env.REACT_APP_ADMIN_API || '/api/admin'),
    profile: normalizePath(process.env.REACT_APP_PROFILE_API || '/api/profile'),
    recharge: normalizePath(process.env.REACT_APP_RECHARGE_API || '/api/recharge'),
    withdrawal: normalizePath(process.env.REACT_APP_WITHDRAWAL_API || '/api/withdrawal'),
    fundhistory: normalizePath(process.env.REACT_APP_FUNDHISTORY_API || '/api/fundhistory'),
    exchange: normalizePath(process.env.REACT_APP_EXCHANGE_API || '/api/exchange'),
    accessRequest: normalizePath(process.env.REACT_APP_ACCESS_REQUEST_API || '/api/access-request'),
  },
  app: {
    name: process.env.REACT_APP_SITE_NAME || 'SuperCoin',
    version: process.env.REACT_APP_VERSION || '1.0.0',
    environment: process.env.NODE_ENV || 'development'
  }
};

export default config;
